import SharedMissingFields from 'components/shared/MissingFields';
import { getMandatoryFileValidations } from 'views/shared/ReferToUnderwriting/helpers';

const MissingFields = () => {
  return (
    <SharedMissingFields
      formStateKey="autoPersonalForm"
      mandatoryFileValidations={getMandatoryFileValidations('autoPersonalForm')}
    />
  );
};

export default MissingFields;
